import React from 'react'
import Confirm from 'views/confirm/confirm'
import { connect } from 'react-redux'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'

import myLibraryActions from 'redux/actions/my_library_actions'
import { localize } from 'helpers/translator'

const MyLibraryEditStoreLessonConfirm = props => (
	<Confirm
		btOne={localize('my_library_edit_store_lesson_button_1')}
		btTwo={localize('my_library_edit_store_lesson_button_2')}
		alertTitle={localize('my_library_edit_store_lesson_title')}
		alertMessage={localize('my_library_edit_store_lesson_message')}
		actionButtonType={0}
		actionOne={() => {
			props.actions.editStoreLesson(props.lessonData)
		}}
		actionTwo={() => {
			props.actions.duplicateLessonConfirmed(props.lessonData)
		}}
		closeAction={() => {
			props.actions.closeEditStoreLessonConfirm()
		}}
	/>
)

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		closeEditStoreLessonConfirm: myLibraryActions.closeEditStoreLessonConfirm,
		duplicateLessonConfirmed: myLibraryActions.duplicateLessonConfirmed,
		editStoreLesson: myLibraryActions.editStoreLesson,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(MyLibraryEditStoreLessonConfirm)
